module.exports = __webpack_public_path__ + "img/bm.9b3d840b.svg";